import React, { useRef } from 'react'

// Styles
import './styles.scss'

// Icons
import IconSeparator from './images/iconSeparator'

export default () => {
  const refSeparator = useRef<HTMLDivElement>(null)

  const newWidth = refSeparator.current?.offsetWidth || 0
  const width = 1096
  const height = 237
  const ratio = width / height

  return (
    <div ref={refSeparator} className={'separator'}>
      <IconSeparator width={'100%'} height={newWidth / ratio - ratio * 5.7} />
    </div>
  )
}
